
export default class AppDrawerContentElement extends HTMLElement {
    constructor(){
        super();
    }
}

customElements.define('app-drawer-content', AppDrawerContentElement);